import React from 'react';
import { Link } from 'react-router-dom';

const Support = () => {
  return (
    <div className="container" style={{ maxWidth: '800px', margin: '20px auto', padding: '20px' }}>
      <h1>Support ASMR.guru</h1>
      <p>Thank you for visiting ASMR.guru! We&apos;re dedicated to bringing you the best ASMR content experience.</p>
      <h2>How You Can Help</h2>
      <p>If you enjoy our service, here are some ways you can support us:</p>
      <ul>
        <li><strong>Share:</strong> Tell your friends and fellow ASMR enthusiasts about ASMR.guru</li>
        <li><strong>Feedback:</strong> Let us know what you think and how we can improve</li>
        <li><strong>Support Creators:</strong> Subscribe to and support the talented ASMR artists featured on our site</li>
        <li><strong>Affiliate Links:</strong> Check out our recommended gear page for equipment suggestions</li>
      </ul>
      <h2>For Content Creators</h2>
      <p>Are you an ASMR content creator? We&apos;d love to feature your work! Reach out to us through <Link to="/contact">our contact page</Link>.</p>
    </div>
  );
};

export default Support;